export const customerData = {
  email: 'DrugSafety@cipla.com',
  phone: '1-888-473-1430 ',
};
